module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_tool_mask.08f6b9bd.png";